(function () {
  'use strict';
  function compactBanner(document, copy) {
    const banner = document.getElementById('shopify-pc__banner');
    if (!banner || !copy || typeof copy.body !== 'string' || !copy.body.trim()
      || typeof copy.accept !== 'string' || !copy.accept.trim()) return;
    const paragraph = banner.querySelector('.shopify-pc__banner__body p');
    const policy = banner.querySelector('#shopify-pc__banner__body-policy-link');
    if (paragraph && policy) {
      const message = copy.body + ' ';
      if (paragraph.childNodes.length !== 2 || paragraph.firstChild.nodeType !== 3
        || paragraph.firstChild.textContent !== message || paragraph.lastChild !== policy) {
        paragraph.replaceChildren(document.createTextNode(message), policy);
      }
      if (typeof copy.privacyUrl === 'string' && copy.privacyUrl.startsWith('/')
        && !copy.privacyUrl.startsWith('//') && policy.getAttribute('href') !== copy.privacyUrl) {
        policy.setAttribute('href', copy.privacyUrl);
      }
    }
    const labels = {
      accept: '#shopify-pc__banner__btn-accept',
      decline: '#shopify-pc__banner__btn-decline',
      preferences: '#shopify-pc__banner__btn-manage-prefs span',
      privacy: '#shopify-pc__banner__body-policy-link',
      title: '#shopify-pc__banner__body-title',
    };
    Object.entries(labels).forEach(([key, selector]) => {
      const node = banner.querySelector(selector);
      if (node && typeof copy[key] === 'string' && copy[key].trim() && node.textContent !== copy[key]) {
        node.textContent = copy[key];
      }
    });
  }
  function positionBanner(document, view) {
    const banner = document.getElementById('shopify-pc__banner');
    if (!banner) return;
    const purchase = document.querySelector('.messagerSticky');
    let offset = 0;
    if (purchase) {
      const style = view.getComputedStyle(purchase);
      const rect = purchase.getBoundingClientRect();
      if (style.display !== 'none' && style.visibility !== 'hidden' && rect.height > 0
        && rect.bottom > 0 && rect.top < view.innerHeight) {
        offset = Math.ceil(view.innerHeight - Math.max(0, rect.top));
      }
    }
    const value = offset + 'px';
    if (banner.style.getPropertyValue('--hlx-cookie-purchase-offset') !== value) {
      banner.style.setProperty('--hlx-cookie-purchase-offset', value);
    }
  }
  // Fields and order buttons of the express order form and the exit popup.
  const ORDER_CONTROLS = ['form.quoteForm', 'form.x_order_form'].map(form =>
    `${form} input:not([type="hidden"]), ${form} button, ${form} [type="submit"]`).join(', ');
  function overlaps(a, b) {
    return a.left < b.right && b.left < a.right && a.top < b.bottom && b.top < a.bottom;
  }
  function placeBanner(document, view) {
    // The fixed banner never moves the page, so comparing both slots with the
    // visible order controls cannot oscillate. Bottom stays the default.
    const banner = document.getElementById('shopify-pc__banner');
    if (!banner) return;
    const rect = banner.getBoundingClientRect();
    if (!(rect.height > 0)) return;
    const gap = 12;
    const offset = parseFloat(banner.style.getPropertyValue('--hlx-cookie-purchase-offset')) || 0;
    const bottomSlot = { left: rect.left, right: rect.right,
      top: view.innerHeight - offset - gap - rect.height, bottom: view.innerHeight - offset - gap };
    const topSlot = { left: rect.left, right: rect.right, top: gap, bottom: gap + rect.height };
    const controls = Array.from(document.querySelectorAll(ORDER_CONTROLS), node => node.getBoundingClientRect())
      .filter(r => r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < view.innerHeight);
    const coveredAtBottom = controls.filter(r => overlaps(r, bottomSlot)).length;
    const coveredAtTop = controls.filter(r => overlaps(r, topSlot)).length;
    const place = coveredAtBottom > 0 && coveredAtTop < coveredAtBottom ? 'top' : 'bottom';
    if (banner.getAttribute('data-hlx-place') !== place) banner.setAttribute('data-hlx-place', place);
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { compactBanner, positionBanner, placeBanner };
    return;
  }
  const source = document.getElementById('hlx-cookie-banner-copy');
  if (!source) return;
  let copy;
  try { copy = JSON.parse(source.textContent); } catch (_) { return; }
  let purchase;
  let pending = false;
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; update(); });
  };
  const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
  const purchaseChanges = new MutationObserver(schedule);
  function update() {
    const current = document.querySelector('.messagerSticky');
    if (current !== purchase) {
      if (resize) resize.disconnect();
      purchaseChanges.disconnect();
      purchase = current;
      if (purchase) {
        if (resize) resize.observe(purchase);
        purchaseChanges.observe(purchase, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
      }
    }
    compactBanner(document, copy);
    positionBanner(document, window);
    placeBanner(document, window);
  }
  update();
  new MutationObserver(schedule).observe(document.body, {
    childList: true, subtree: true,
  });
  const pageChanges = new MutationObserver(schedule);
  [document.documentElement, document.body].forEach(node => pageChanges.observe(node, {
    attributes: true, attributeFilter: ['class', 'style'],
  }));
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('scroll', schedule, { passive: true });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule, { passive: true });
})();
